var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pravo-sirsi__welcome__button"},[_c('router-link',{attrs:{"to":"/join"}},[_c('div',{staticClass:"pravo-sirsi__welcome__button__img"},[_c('div',{staticClass:"pravo-sirsi__welcome__button__img__img"})]),_c('span',{staticClass:"pravo-sirsi__welcome__button__text"},[_vm._v("Game overview")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }